var routes = {
  '/': {
    templateUrl: 'login.partial.html',
    controller: 'AuthController',
    controllerAs: 'login',
    auth: false
  },
  '/datastream' : {
    templateUrl: 'datastream-landing.partial.html',
    controller: 'IndexController',
    controllerAs: 'index',
    resolve: {
      referrer: function($window, $route, Base64){
        try {
          localStorage['__referrer'] = Base64.decode($route.current.params.r)
          return $route.current.params.r
        }
        catch(err) {
          return null;
        }
      }
    },
    auth: false
  },
  '/search' : {
    templateUrl: 'search.partial.html',
    controller: 'SearchController',
    controllerAs: 'search',
    auth: true,
    resolve: {
      user: function($log, CurrentUserService) { return CurrentUserService.get(); }
    }
  },
  '/account-management' : {
    templateUrl: 'account-management.partial.html',
    controller: 'AccountManagementController',
    controllerAs: 'acctManagement',
    auth: true,
    resolve: {
      user: function($log, CurrentUserService) { return CurrentUserService.get(); }
    }
  },
  '/account-management/page/:page' : {
    templateUrl: 'account-management.partial.html',
    controller: 'AccountManagementController',
    controllerAs: 'acctManagement',
    auth: true,
    resolve: {
      user: function($log, CurrentUserService) { return CurrentUserService.get(); }
    }
  },
  '/alerts-management' : {
    templateUrl: 'alerts-management.partial.html',
    controller: 'AlertsManagementController',
    controllerAs: 'alertsManagement',
    auth: true,
    resolve: {
      user: function($log, CurrentUserService) { return CurrentUserService.get(); }
    }
  },
  '/alerts-history' : {
    templateUrl: 'alerts-history.partial.html',
    controller: 'AlertsHistoryController',
    controllerAs: 'alertsHistory',
    auth: true,
    resolve: {
      user: function($log, CurrentUserService) { return CurrentUserService.get(); }
    }
  },
 '/signup': {
   templateUrl: 'signup.partial.html',
   controller: 'SignupController',
   controllerAs: 'signup',
   auth: false
 },
  '/confirm/:id': {
    templateUrl: 'signup-final.partial.html',
    controller: 'ConfirmationController',
    controllerAs: 'confirm',
    auth: false,
    resolve: {
      registration: function($route, Registration) {
        return Registration.get({id: $route.current.params.id}).$promise.then(
          function(r) { return r },
          function(error) { return null }
        )
      }
    }
  },
  '/search-form': {
    templateUrl: 'search-form.partial.html',
    controller: 'SearchFormController',
    controllerAs: 'sfc',
    auth: true,
    resolve: {
      user: function($log, CurrentUserService) { return CurrentUserService.get(); }
    }
  },
  '/detail/:id?': {
    templateUrl: 'detail-result.partial.html',
    controller: 'DetailResultController',
    controllerAs: 'drc',
    auth: true,
    resolve: {
      user: function($log, CurrentUserService) { return CurrentUserService.get(); },
      recordId: function($route) {return $route.current.params.id; }
    }
  },
  '/login': {
    templateUrl: 'login.partial.html',
    controller: 'AuthController',
    controllerAs: 'login',
    auth: false
  },
  '/reset-password/:token': {
    templateUrl: 'password-reset.partial.html',
    controller: 'PasswordResetController',
    controllerAs: 'reset',
    auth: false,
    resolve: {
      validReset: function(PasswordResetService, $route) {
        return PasswordResetService.validateResetToken($route.current.params.token)
      }
    }
  },
  '/reset-password': {
    templateUrl: 'request-password-reset.partial.html',
    controller: 'PasswordResetController',
    controllerAs: 'reset',
    auth: false
  },
  '/contact': {
    templateUrl: 'contact-us.partial.html',
    controller: 'ContactController',
    controllerAs: 'contact',
    auth: false
  }
}

export default routes
